module.exports = __webpack_public_path__ + "static/media/FRM-Logo.dafa3131.png";